import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectFilter from './SelectFilter';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';

const ShelfFilter = ({
  shelves,
  onChangeFilter,
  loading,
  isMulti,
  isClearable,
  placeholder,
}) => (
  <SelectFilter
    isMulti={isMulti}
    isClearable={isClearable}
    isLoading={loading}
    onChangeFilter={onChangeFilter}
    options={shelves}
    placeholder={placeholder}
  />
);

ShelfFilter.propTypes = {
  shelves: optionsPropTypes,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ShelfFilter.defaultProps = {
  shelves: [],
  loading: false,
  isMulti: false,
  isClearable: false,
  placeholder: 'Seleccionar Anaquel',
};

const mapStateToProps = ({ CargoUnit }) => ({
  shelves: CargoUnit.Shelf.getIn(['all', 'content', 'content']).map(
    (shelf) => ({
      value: shelf.id,
      label: shelf.name,
    }),
  ),
  loading: CargoUnit.Shelf.getIn(['all', 'loading']),
});

export default connect(mapStateToProps)(ShelfFilter);
